import { reportsApi } from 'Api/axios/reports-api';
import useCoursesReportApi from 'Hooks/useCoursesReportApi';
import useTranslation from 'Hooks/useTranslation';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import type { CourseReportFilterI } from 'types';
import { downloadFile } from 'Utils/file-utils';

const useCoursesReportPage = () => {
  const { t2 } = useTranslation('courses_reports');
  const [currentFilters, setCurrentFilters] = useState<CourseReportFilterI>({});
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(15);

  const {
    data: coursesReportData,
    pagination,
    loading,
    error,
    fetchCoursesReport,
  } = useCoursesReportApi({ init: false });

  useEffect(() => {
    fetchCoursesReport({ ...currentFilters, page, pageSize });
  }, [page, pageSize, currentFilters]);

  const onSearch = (filters: CourseReportFilterI) => {
    setPage(1);
    setCurrentFilters(filters);
  };

  const handlePageChange = (newPage: number) => setPage(newPage);
  const handleRowsPerPageChange = (newPageSize: number) => {
    setPage(1);
    setPageSize(newPageSize);
  };

  const onExport = async () => {
    const response = await reportsApi.exportCourses(currentFilters);
    if (response.data) {
      downloadFile(response.data, `cursos_reporte.xlsx`);
      toast.success(t2('export_success'));
    }
  };

  return {
    t2,
    onSearch,
    coursesReportData,
    pagination,
    loading,
    error,
    handlePageChange,
    handleRowsPerPageChange,
    onExport,
  };
};

export default useCoursesReportPage;
